import { render, staticRenderFns } from "./CoreBottomSheet.vue?vue&type=template&id=0e5a28c4&scoped=true&"
import script from "./CoreBottomSheet.vue?vue&type=script&lang=ts&setup=true&"
export * from "./CoreBottomSheet.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./CoreBottomSheet.vue?vue&type=style&index=0&id=0e5a28c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e5a28c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e5a28c4')) {
      api.createRecord('0e5a28c4', component.options)
    } else {
      api.reload('0e5a28c4', component.options)
    }
    module.hot.accept("./CoreBottomSheet.vue?vue&type=template&id=0e5a28c4&scoped=true&", function () {
      api.rerender('0e5a28c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/core/CoreBottomSheet/CoreBottomSheet.vue"
export default component.exports